import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notif, setNotif] = useState({
    show: false,
    type: '',
    message: ''
  });

  const showNotif = useCallback((type, message, duration = 1000) => {
    setNotif({ show: true, type, message });

    setTimeout(() => {
      setNotif({ show: false, type: '', message: '' });
    }, duration);
  }, []);

  const contextValue = useMemo(() => ({ showNotif }), [showNotif]);

  return (
    <NotificationContext.Provider value={contextValue}>
      {children}

      {/* Modal ditaruh di sini agar GLOBAL */}
      {notif.show && (
        <div
          className="modal fade show"
          style={{
            display: 'block',
            backgroundColor: 'rgba(0,0,0,0)',
            zIndex: 120000,
            pointerEvents: 'none'
          }}
        >
          <div className="modal-dialog modal-sm modal-dialog-centered">
            <div className="modal-content">
              <div
                className={`modal-body text-center text-white ${
                  notif.type === 'success'
                    ? 'bg-success'
                    : notif.type === 'error'
                    ? 'bg-danger'
                    : 'bg-secondary'
                }`}
              >
                {notif.message}
              </div>
            </div>
          </div>
        </div>
      )}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
